module.exports = __webpack_public_path__ + "img/preview-4.8ada52b2.webp";